import { NgModule } from "@angular/core";

import { RecaptchaComponent } from "./recaptcha.component";

@NgModule({
  imports: [RecaptchaComponent],
  exports: [RecaptchaComponent],
})
export class RecaptchaCommonModule {}
